export default "__VITE_ASSET__CTONmL2V__"